var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { ItemStyle } from '../DuoColumnSelector.Styles';
import { isIOption } from '../../types/commonTypes';
export var Item = function (_a) {
    var value = _a.value, id = _a.id, onItemClick = _a.onItemClick;
    var text = isIOption(value) ? value.label : value;
    var val = isIOption(value) ? value.value : value;
    return (React.createElement(Draggable, { draggableId: val, index: id, key: val + id }, function (provided) { return (React.createElement(ItemStyle, __assign({}, provided.draggableProps, provided.dragHandleProps, { innerRef: provided.innerRef, onClick: function () { return onItemClick(value, id); } }), text)); }));
};
Item.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=Item.js.map